import { put, call } from "redux-saga/effects";
import { BACK_TO_LOGIN } from "../../constants/ActionTypes";
import { history } from "../store";
import { getPath } from "../../util/logoHelper";

export const AUTH_INQUIRY_SUCCESS = ["INQ000"];

export const IDP_INQUIRY_SUCCESS = [
    'INQ000',
    'MEM000',
    'MER019',
    'MER002',
    'STR000',
    'STR903',
    'CURRENCY02',
];

export const IDP_MUTATION_SUCCESS = [
    'MER017',
    'MER020',
    'MER022',
    'MER023',
    'STR900',
    'STR904',
    'STR906',
    'MEM907',
];

export const IDP_REGISTRATION_VERIFY_SUCCESS = ['MEM000', 'USER000'];

export const AUTH_MUTATION_SUCCESS = [
    "USER010",
    "USER011",
    "USER009",
    "USER004",
    "ROLE000",
    "ROLE001",
    "ROLE002",
    "MEM902",
];

export const NOTIFICATION_INQUIRY_SUCCESS = ['INQ000'];

export const NOTIFICATION_MUTATION_SUCCESS = ['INQ003', 'INQ004'];

export const NOTIFICATION_DELETE_SUCCESS = ['MB005'];

export const AUTH_PASSWORD_FORGOT_SUCCESS = ['USER002'];

export const AUTH_PASSWORD_RESET_SUCCESS = ['USER004'];

function extractResponseMeta(data) {
    const abstractResponse = data && data.abstractResponse;
    const responseCode =
        (data && data.responseCode) ||
        (data && data.responseStatus) ||
        (abstractResponse && abstractResponse.responseStatus);

    const responseMessage =
        (data && data.responseMessage) ||
        (abstractResponse && abstractResponse.responseMessage);

    return { responseCode, responseMessage };
}

export function* apiHandler(apiFn, payload, options = {}) {
    const successCodes = options.successCodes || AUTH_INQUIRY_SUCCESS;

    try {
        const response = yield call(apiFn, payload);
        const data = response && response.data;
        const { responseCode, responseMessage } = extractResponseMeta(data);

        if (successCodes.indexOf(responseCode) !== -1) {
            return {
                ok: true,
                data: data,
            };
        }

        if (responseCode === "ERROR37") {
            history.push(getPath("/forbidden"));
            return {
                ok: false,
                message: responseMessage || "Access Denied",
            };
        }

        return {
            ok: false,
            message: responseMessage || "Unknown error",
        };
    } catch (error) {
        const hasResponse = error && error.response;
        const data = hasResponse && error.response.data;
        const { responseCode: status, responseMessage: message } = extractResponseMeta(data);

        const resolvedMessage =
            message || "Sorry, this feature is not accessible at this time.";

        if (
            !options.suppressAuthRedirect &&
            (status === "AUTH001" || status === "AUTH401")
        ) {
            yield put({
                type: BACK_TO_LOGIN,
                payload: resolvedMessage,
            });

            return {
                ok: false,
                message: resolvedMessage,
            };
        }

        if (status === "ERROR37") {
            history.push(getPath("/forbidden"));
            return {
                ok: false,
                message: resolvedMessage,
            };
        }

        return {
            ok: false,
            message: resolvedMessage,
        };
    }
}
